<template>
  <div id="myDateShow">
    <div class="title">查看 用户优惠券资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">用户ID</div>
        <div class="value">{{userCoupons.userId}}</div>
      </div>
      <div class="line">
        <div class="key">优惠券</div>
        <div class="value">{{userCoupons.coupons.couponsName}}</div>
      </div>
      <div class="line">
        <div class="key">RNMID码</div>
        <div class="value">{{userCoupons.rnmIdCode}}</div>
      </div>
      <div class="line">
        <div class="key">状态</div>
        <div class="value">{{userCoupons.state}}</div>
      </div>
      <div class="line">
        <div class="key">领取时间</div>
        <div class="value">
          {{userCoupons.getDate}}
        </div>
      </div>
      <div class="line">
        <div class="key">领取方式</div>
        <div class="value">{{userCoupons.getDescribe}}</div>
      </div>
      <div class="line">
        <div class="key">使用时间</div>
        <div class="value">{{userCoupons.useDate}}</div>
      </div>
      <div class="line">
        <div class="key">使用方式</div>
        <div class="value">{{userCoupons.useDescribe}}</div>
      </div>
      <div class="line">
        <div class="key">过期时间</div>
        <div class="value">{{userCoupons.endDate}}次</div>
      </div>
      <div class="line">
        <div class="key">可用次数</div>
        <div class="value">{{userCoupons.userCouponsCount}}次</div>
      </div>

      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getUserCouponsById,newVue} from "../../network/userCoupons";

  export default {
    name: "userCouponsData",
    components: {},
    data(){
      return{
        userCouponsId:"",
        userCoupons:{}
      }
    },
    methods:{
      backClick(){
        this.$router.push("../list");
      },
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/userCoupons/list";
      this.common.HeaderLocationTwo.name =  "用户优惠券管理"
      this.common.HeaderLocationThree.name = "用户优惠券详情"
      console.log(this.$route.params.id);
      this.userCouponsId = this.$route.params.id;

      getUserCouponsById(this.userCouponsId).then(res => {
        this.userCoupons = res.data
      })
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
</style>
